import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as gamePlanAction from '../actions/gameplan.action';
import { UpdateService } from 'src/app/_clusters/services/update.service';
import { catchError, delay, map, mergeMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { StudentJourneyService } from 'src/app/_clusters/services/student-journey.service';

@Injectable()
export class gamePlanEffect {
  constructor(private actions$: Actions, private updateService:UpdateService, 
    private studentJourney:StudentJourneyService
  ) {}

  loadUsers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(gamePlanAction.loadGamePlan),
      mergeMap((payload) =>
        this.updateService.getStudentGameplanStatus(payload.payload).pipe(
          map((gamePlanActive:any) => gamePlanAction.loadGamePlanSuccess({ gamePlanActive })),
          catchError(error => of(gamePlanAction.loadGamePlanFailure({ error })))
        )
      )
    )
  );


  loadStudentJourney$ = createEffect(() =>
    this.actions$.pipe(
      ofType(gamePlanAction.loadGamePlanJourney),
      mergeMap(() =>
        this.studentJourney.getStudentJourney().pipe(
            // delay(500),
          map((journeyData:any) => gamePlanAction.loadGamePlanJourneySuccess({ journeyData })),
          catchError(error => of(gamePlanAction.loadGamePlanJourneyFailure({ error })))
        )
      )
    )
  );
}
